<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import TwuUploader from './TwuUploader'

export default {
  props: {
    job: {
      type: Object
    }
  },

  components: {
    TwuUploader
  },

  data() {
    const data = this.job

    return {
      loading_img: false,
      loading_error: null,
      job_category_id: data ? data.job_category_id : '',
      job_type_id: data ? data.job_type_id : '',
      logo: data ? data.logo : '',
      title: data ? data.title : '',
      company: data ? data.company : '',
      whatwedo: data ? data.whatwedo : '',
      tags: data ? data.tags : '',
      city: data ? data.city : '',
      postal_code: data ? data.postal_code : '',
      country: data ? data.country : 'France',
      description: data ? data.description : '',
      is_startup: data ? data.is_startup : false
    }
  },

  validations () {
    const grouped = {
      req: {
        required
      },
      req_max64: {
        required,
        maxLength: maxLength(64)
      },
      max64: {
        maxLength: maxLength(64)
      }
    }

    return {
      job_category_id: grouped.req,
      job_type_id: grouped.req,
      title: grouped.req_max64,
      company: grouped.req_max64,
      whatwedo: grouped.req_max64,
      tags: grouped.max64,
      city: grouped.req,
      country: grouped.req
    }
  },

  computed: {
    file_text() {
      if (this.loading_img) {
        return 'Chargement...'
      } else if (this.loading_error) {
        return this.loading_error
      } else {
        return this.logo
      }
    }
  },

  methods: {
    save() {
      this.$v.$touch()

      if (this.$v.$error) {
        return
      }

      const data = {
        job_category_id: this.job_category_id,
        job_type_id: this.job_type_id,
        logo: this.logo,
        title: this.title,
        company: this.company,
        whatwedo: this.whatwedo,
        tags: this.tags,
        city: this.city,
        postal_code: this.postal_code,
        country: this.country,
        description: this.description,
        is_startup: this.is_startup
      }

      this.Loading.yes = true

      if (this.job) {
        this.axios.put('/jobs/' + this.job.id, data)
          .then(this.onSaved)
          .finally(() => (this.Loading.yes = false))
      } else {
        this.axios.post('/jobs', data)
          .then(this.onSaved)
          .finally(() => (this.Loading.yes = false))
      }
    },

    onSaved() {
      if (!this.job) {
        Object.assign(this.$data, this.$options.data.call(this))
      }

      this.$alert({
        type: 'success',
        trans: 'messages.job_added'
      })

      this.$v.$reset()
      window.scroll(0, 0)
    },

    uploadStart() {
      this.loading_img = true
      this.loading_error = null
    },

    uploadError(error) {
      this.loading_img = false

      if (error.response.status === 422) {
        this.loading_error = error.response.data.file[0]
      } else {
        this.loading_error = 'errors.' + error.response.data.error
      }
    },

    uploadDone(response) {
      this.loading_img = false
      this.loading_error = null
      this.logo = response.data.path
    }
  }
}
</script>

<template>
    <form @submit.prevent="save" class="box">
      <div class="field">
        <div class="columns">

          <div class="column is-8">
            <label for="title">Titre</label>
            <input type="text" class="input" id="title" v-model.trim="title">
            <p
              class="help is-danger"
              v-show="$v.$error && !$v.title.required">
              Champ obligatoire
            </p>
            <p
              class="help is-danger"
              v-show="$v.$error && !$v.title.maxLength">
              Maximum {{ $v.title.$params.maxLength.max }} caractères
            </p>
          </div>

          <div class="column is-4">
            <div class="file has-name is-boxed">
              <label class="file-label">
                <twu-uploader
                  url="upload"
                  @start="uploadStart"
                  @done="uploadDone"
                  @error="uploadError"/>
                <span class="file-cta">
                  <span class="file-label">
                    Uploader logo
                  </span>
                </span>
                <span
                  class="file-name"
                  v-show="file_text">
                  {{ file_text }}
                </span>
              </label>
            </div>
          </div>

        </div>
      </div>

      <div class="field">
        <div class="columns">

          <div class="column is-3">
            <label for="job_category_id">Catégorie</label>
            <br>
            <div class="select">
              <select id="job_category_id" v-model.trim.number="job_category_id">
                <option value="">Choisir...</option>
                <option value="1">DESIGN</option>
                <option value="2">DEV FRONT</option>
                <option value="3">DEV BACK</option>
                <option value="4">Autre</option>
              </select>
            </div>
            <p
              class="help is-danger"
              v-show="$v.$error && !$v.job_category_id.required">
              Champ obligatoire
            </p>
          </div>

          <div class="column is-3">
            <label for="job_type_id">Type de poste</label>
            <br>
            <div class="select is-3">
              <select id="job_type_id" v-model.trim.number="job_type_id">
                <option value="">Choisir...</option>
                <option value="1">Stage</option>
                <option value="2">Alternance</option>
              </select>
            </div>

            <p
              class="help is-danger"
              v-show="$v.$error && !$v.job_type_id.required">
              Champ obligatoire
            </p>
          </div>

          <div class="column">
            <label class="checkbox">
              <input type="checkbox" v-model="is_startup">
              Startup
            </label>
          </div>

        </div>
      </div>

      <div class="field">
        <label for="company">Entreprise</label>
        <input type="text" class="input" id="company" v-model.trim="company">
        <p
          class="help is-danger"
          v-show="$v.$error && !$v.company.required">
          Champ obligatoire
        </p>
       <p
          class="help is-danger"
          v-show="$v.$error && !$v.company.maxLength">
          Maximum {{ $v.company.$params.maxLength.max }} caractères
        </p>
      </div>

      <div class="field">
        <label for="whatwedo">Ce qu'on fait (startup de transport de...)</label>
        <input type="text" class="input" id="whatwedo" v-model.trim="whatwedo">
        <p
          class="help is-danger"
          v-show="$v.$error && !$v.whatwedo.required">
          Champ obligatoire
        </p>
       <p
          class="help is-danger"
          v-show="$v.$error && !$v.whatwedo.maxLength">
          Maximum {{ $v.whatwedo.$params.maxLength.max }} caractères
        </p>
      </div>

      <div class="field">
        <label for="tags">Mots clés (séparés par des virgules)</label>
        <input type="text" class="input" id="tags" v-model.trim="tags">
       <p
          class="help is-danger"
          v-show="$v.$error && !$v.tags.maxLength">
          Maximum {{ $v.tags.$params.maxLength.max }} caractères
        </p>
      </div>

      <div class="field">
        <label for="city">Ville</label>
        <input type="text" class="input" id="city" v-model.trim="city">
        <p
          class="help is-danger"
          v-show="$v.$error && !$v.city.required">
          Champ obligatoire
        </p>
      </div>

      <div class="field">
        <label for="postal_code">Code postal</label>
        <input type="text" class="input" id="postal_code" v-model.trim="postal_code">
      </div>

      <div class="field">
        <label for="country">Pays</label>
        <input type="text" class="input" id="country" v-model.trim="country">
        <p
          class="help is-danger"
          v-show="$v.$error && !$v.country.required">
          Champ obligatoire
        </p>
      </div>

      <div class="field">
        <label for="description">Description</label>
        <br>
        <textarea type="text" class="input" id="description" v-model.trim="description"></textarea>
      </div>

      <div class="field has-text-centered">
        <button class="button is-success">
          Ajouter
        </button>
      </div>
    </form>
</template>

<style scoped>
textarea {
  height: 150px;
}

.columns {
  align-items: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/JobForm.vue